const compactHandleSizePx = 8;

const compactHandleOffsetPx = -compactHandleSizePx / 2;

const compactHandleSize = {
  width: compactHandleSizePx,
  height: compactHandleSizePx,
};

export const smallElementCornerHandleStyles = {
  topLeft: { ...compactHandleSize, top: compactHandleOffsetPx, left: compactHandleOffsetPx },
  topRight: { ...compactHandleSize, top: compactHandleOffsetPx, right: compactHandleOffsetPx },
  bottomLeft: { ...compactHandleSize, bottom: compactHandleOffsetPx, left: compactHandleOffsetPx },
  bottomRight: {
    ...compactHandleSize,
    bottom: compactHandleOffsetPx,
    right: compactHandleOffsetPx,
  },
};
